import { Injectable, Injector } from '@angular/core';
import { ToastService } from '@app/core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class UtilsService {
    constructor(
        private toastrService: ToastService,
        private readonly injector: Injector
    ) {}

    checkMaxFilesize(filesize: number) {
        const maxFileSize = environment.maxFileSize; // 20 MB
        if (filesize > maxFileSize) {
            const translate = this.injector.get(TranslateService);
            this.toastrService.error(translate.instant('ERRORS.FILESIZE'));
            return false;
        }
        return true;
    }

    downloadBlob(blob: Blob, filename: string): void {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
    }
}
